export const formatFloat = (value, numDecimals=1, ratio=false) => {
  if (value === null || value === undefined || isNaN(value) || !isFinite(value)) {
    return '—';
  }
  if (ratio) {
    value *= 100;
  }
  if ((value > -0.5 * 10**-numDecimals) && (value <= 0)) {
    value = 0;
  }
  return value.toLocaleString('en-US', {
    minimumFractionDigits: numDecimals,
    maximumFractionDigits: numDecimals,
  });
};

export const floatFormatter = (numDecimals=1) => {
  return value => formatFloat(value, numDecimals);
};

export const formatPercent = (value, numDecimals) => {
  return formatUnit(value, '%', numDecimals, true);
};


export const formatRatioPercent = (value, numDecimals) => {
  return formatUnit(value, '%', numDecimals, true);
};


export const formatRatio = (value, numDecimals) => {
  return formatFloat(value, numDecimals, true);
};


export const formatGrowth = (value, formatFunc=formatRatioPercent) => {
  if (value > 0) {
    return '+' + formatFunc(value);
  }
  return formatFunc(value);
};


export const formatUnit = (value, unit, numDecimals, ratio) => {
  let formatted = formatFloat(value, numDecimals, ratio);
  if (value === null || value === undefined || !unit) {
    return formatted;
  }
  return `${formatted} ${unit}`;
};


export const autoFormatUnit = (value, unit) => {
  const isRatio = unit === '%';
  return formatUnit(value, unit, isRatio ? 1 : 0, isRatio);
};


export const unitFormatter = (unit, numDecimals) => {
  return value => formatUnit(value, unit, numDecimals);
};


export const formatVolume = (value, unit, numDecimals) => {
  return formatUnit(value, unit, numDecimals);
};


export const autoFormat = (value, numDecimals) => {
  if (value === null) {
    return '—';
  }
  if (Number.isInteger(value)) {
    return value;
  }
  if (Number.isFinite(value)) {
    return formatFloat(value, numDecimals);
  }
  return value;
};


export const round = (value, numDecimals=0) => {
  if (Number.isFinite) {
    const multiplier = (10 ** numDecimals);
    return Math.round(value * multiplier) / multiplier;
  }
  return value;
};


export const roundUnit = (value, unit) => {
  return round(value, unit === '%' ? 3 : 0);
};

export const clipRatio = ratio => Math.max(Math.min(ratio, 1.0), 0.0);